import { useEffect } from 'react';
import type { NotificationServiceRoot } from 'src/apis/notification-service/types';
import { useAxios } from 'src/hooks/use-axios';

export function useNotificationServicePublic() {
  const notificationService = useAxios(
    (axios, baseConfig) =>
      axios.request<NotificationServiceRoot>({
        ...baseConfig,
        url: PRISMA_CONFIG.notificationService,
      }),
    { neededOnPageLoad: true, cacheKey: 'notification-service-root' }
  );

  useEffect(() => {
    notificationService.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return notificationService;
}

export type NotificationServiceRequest = ReturnType<
  typeof useNotificationServicePublic
>;
